export default __webpack_public_path__ + "static/top-rock-at-night-0a031b9bb75222ded1dd5fb55bb7a01e.jpg";